import { SSO_CLIENT, SSO_PROVIDER_PLATFORM, SSO_PROVIDER_TYPE } from './types'
import type { SSOClientConfig } from './types'
import { ssoStorage } from './ssoStorage'

export const DEFAULT_OAUTH_SCOPES = ['openid', 'email', 'profile']
const COGNITO_USER_ADMIN_OAUTH_SCOPE = 'aws.cognito.signin.user.admin'

const sharedSSOClientConfigs: SSOClientConfig[] = [
  {
    clientName: SSO_CLIENT.HDA,
    identityProvider: process.env.REACT_APP_HDA_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_HDA_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_HDA_ORG_ID,
    clinicId: process.env.REACT_APP_HDA_CLINIC_ID,
    forcePhoneNumber: process.env.REACT_APP_HDA_PHONE_NUMBER,
    prescriberOnly: true,
    providerPlatform: SSO_PROVIDER_PLATFORM.AZURE_AD,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
  {
    clientName: SSO_CLIENT.SLHD,
    identityProvider: process.env.REACT_APP_EHNSW_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_EHNSW_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_SLHD_ORG_ID,
    clinicId: process.env.REACT_APP_SLHD_CLINIC_ID,
    prescriberOnly: false,
    requiresJoinRequestApproval: true,
    providerPlatform: SSO_PROVIDER_PLATFORM.OAM,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
  {
    clientName: SSO_CLIENT.CONSULTMED,
    identityProvider: process.env.REACT_APP_CONSULTMED_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_CONSULTMED_COGNITO_CLIENT_ID,
    providerId: process.env.REACT_APP_CONSULTMED_TENANT_PROVIDER_ID,
    providerPlatform: SSO_PROVIDER_PLATFORM.AUTH0,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.TELECARE,
    identityProvider: process.env.REACT_APP_TELECARE_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_TELECARE_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_CLINIC_ID,
    forcePhoneNumber: process.env.REACT_APP_HDA_PHONE_NUMBER,
    prescriberOnly: true,
    providerPlatform: SSO_PROVIDER_PLATFORM.AZURE_AD,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
  {
    clientName: SSO_CLIENT.TELADOC_SOLO,
    identityProvider: process.env.REACT_APP_TELADOC_SOLO_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELADOC_SOLO_COGNITO_CLIENT_ID,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
]

const prodOnlySSOClientConfigs: SSOClientConfig[] = [
  {
    clientName: SSO_CLIENT.TELECARE_OPAU_CHHHS,
    identityProvider: process.env.REACT_APP_TELECARE_OPAU_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OPAU_COGNITO_CLIENT_ID,
    orgId: process.env.REACT_APP_TELECARE_OPAU_CHHHS_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OPAU_CHHHS_CLINIC_ID,
    providerId: process.env.REACT_APP_TELECARE_OPAU_TENANT_PROVIDER_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.COGNITO,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.TELECARE_OPAU_RHC,
    identityProvider: process.env.REACT_APP_TELECARE_OPAU_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OPAU_COGNITO_CLIENT_ID,
    orgId: process.env.REACT_APP_TELECARE_OPAU_RHC_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OPAU_RHC_CLINIC_ID,
    providerId: process.env.REACT_APP_TELECARE_OPAU_TENANT_PROVIDER_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.COGNITO,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.TELECARE_OPAU_WBHHS,
    identityProvider: process.env.REACT_APP_TELECARE_OPAU_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OPAU_COGNITO_CLIENT_ID,
    orgId: process.env.REACT_APP_TELECARE_OPAU_WBHHS_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OPAU_WBHHS_CLINIC_ID,
    providerId: process.env.REACT_APP_TELECARE_OPAU_TENANT_PROVIDER_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.COGNITO,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.TELECARE_OPAU_CQLD,
    identityProvider: process.env.REACT_APP_TELECARE_OPAU_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OPAU_COGNITO_CLIENT_ID,
    orgId: process.env.REACT_APP_TELECARE_OPAU_CQLD_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OPAU_CQLD_CLINIC_ID,
    providerId: process.env.REACT_APP_TELECARE_OPAU_TENANT_PROVIDER_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.COGNITO,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.TELECARE_OPAU_MNHHS,
    identityProvider: process.env.REACT_APP_TELECARE_OPAU_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OPAU_COGNITO_CLIENT_ID,
    orgId: process.env.REACT_APP_TELECARE_OPAU_MNHHS_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OPAU_MNHHS_CLINIC_ID,
    providerId: process.env.REACT_APP_TELECARE_OPAU_TENANT_PROVIDER_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.COGNITO,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.NSW_AMBULANCE,
    identityProvider: process.env.REACT_APP_EHNSW_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_EHNSW_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_NSW_AMBULANCE_ORG_ID,
    clinicId: process.env.REACT_APP_NSW_AMBULANCE_CLINIC_ID,
    prescriberOnly: false,
    requiresJoinRequestApproval: true,
    providerPlatform: SSO_PROVIDER_PLATFORM.OAM,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
  {
    clientName: SSO_CLIENT.EVERLAB,
    identityProvider: process.env.REACT_APP_EVERLAB_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_EVERLAB_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_EVERLAB_ORG_ID,
    prescriberOnly: false,
    clinicId: process.env.REACT_APP_EVERLAB_CLINIC_ID,
    providerPlatform: SSO_PROVIDER_PLATFORM.CLOUDFLARE,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
]

const devOnlySSOClientConfigs: SSOClientConfig[] = [
  {
    clientName: SSO_CLIENT.TELECARE_AUTH0,
    identityProvider: process.env.REACT_APP_TELECARE_AUTH0_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_AUTH0_COGNITO_CLIENT_ID,
    providerId: process.env.REACT_APP_TELECARE_AUTH0_TENANT_PROVIDER_ID,
    providerPlatform: SSO_PROVIDER_PLATFORM.AUTH0,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.TELECARE_JC,
    identityProvider: process.env.REACT_APP_TELECARE_JC_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_JC_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_TELECARE_JC_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_JC_CLINIC_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.JUMP_CLOUD,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
  {
    clientName: SSO_CLIENT.EVERLAB_JC,
    identityProvider: process.env.REACT_APP_EVERLAB_JC_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_EVERLAB_JC_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_EVERLAB_JC_ORG_ID,
    prescriberOnly: false,
    clinicId: process.env.REACT_APP_EVERLAB_JC_CLINIC_ID,
    providerPlatform: SSO_PROVIDER_PLATFORM.JUMP_CLOUD,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
  {
    clientName: SSO_CLIENT.TELECARE_OPAU_SCMC,
    identityProvider: process.env.REACT_APP_TELECARE_OPAU_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OPAU_COGNITO_CLIENT_ID,
    orgId: process.env.REACT_APP_TELECARE_OPAU_SCMC_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OPAU_SCMC_CLINIC_ID,
    providerId: process.env.REACT_APP_TELECARE_OPAU_TENANT_PROVIDER_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.COGNITO,
    providerType: SSO_PROVIDER_TYPE.OIDC,
  },
  {
    clientName: SSO_CLIENT.TELECARE_OAM,
    identityProvider: process.env.REACT_APP_TELECARE_OAM_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OAM_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_TELECARE_OAM_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OAM_CLINIC_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.OAM,
    requiresJoinRequestApproval: true,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
  {
    clientName: SSO_CLIENT.TELECARE_OAM_2,
    identityProvider: process.env.REACT_APP_TELECARE_OAM_COGNITO_IDENTITY_PROVIDER,
    clientId: process.env.REACT_APP_TELECARE_OAM_COGNITO_CLIENT_ID,
    oauthScopes: [...DEFAULT_OAUTH_SCOPES, COGNITO_USER_ADMIN_OAUTH_SCOPE],
    orgId: process.env.REACT_APP_TELECARE_OAM_2_ORG_ID,
    clinicId: process.env.REACT_APP_TELECARE_OAM_2_CLINIC_ID,
    prescriberOnly: false,
    providerPlatform: SSO_PROVIDER_PLATFORM.OAM,
    requiresJoinRequestApproval: true,
    providerType: SSO_PROVIDER_TYPE.SAML,
  },
]

const isDevelopment = process.env.REACT_APP_ENVIRONMENT === 'development'

export const ssoClientConfigMappings: SSOClientConfig[] = isDevelopment
  ? [...sharedSSOClientConfigs, ...devOnlySSOClientConfigs]
  : [...sharedSSOClientConfigs, ...prodOnlySSOClientConfigs]

/**
 * Resolves the current SSO client config by first trying the clientName
 * stored in clientSSOContext (unique per client), then falling back to
 * clientId lookup. This avoids ambiguity when multiple clients share
 * the same Cognito clientId (e.g. all OPAU clients).
 */
export const getSSOClientConfig = (): SSOClientConfig | undefined => {
  const context = ssoStorage.getContext()
  if (context?.clientName) {
    const match = ssoClientConfigMappings.find((c) => c.clientName === context.clientName)
    if (match) return match
  }
  const clientId = localStorage.getItem('client_id') || ''
  return ssoClientConfigMappings.find((client) => client.clientId === clientId)
}
